import {
    formSupportsBillingAdditionalAddressInfo,
    formSupportsShippingAdditionalAddressInfo,
} from "@features/checkout/components/delivery-step/FormsConfig";
import { COUNTRY_ADDRESS_CONFIG } from "@lib/constants/addresses";
import type { CountryCode } from "@config/site/types";
import type { DeliveryInitialValues } from "@lib/utils/checkoutHelper";

const HOUSE_NUMBER_ONLY = /^\d+(?:[a-z]\d*)?(?:[-/](?:\d+[a-z]?|[a-z]))?$/i;

export const mapApplePayAddressLines = (
    addressLines?: string[],
    countryCode?: string
): { streetName: string; additionalAddressInfo: string } => {
    const lines = (addressLines ?? []).map((line) => line.trim()).filter(Boolean);
    const [firstLine = "", secondLine, ...remainingLines] = lines;
    const mergeLeadingHouseNumber =
        COUNTRY_ADDRESS_CONFIG[countryCode?.toUpperCase() as CountryCode]
            ?.mergeLeadingHouseNumber ?? true;

    if (mergeLeadingHouseNumber && secondLine && HOUSE_NUMBER_ONLY.test(firstLine)) {
        return {
            streetName: `${firstLine} ${secondLine}`,
            additionalAddressInfo: remainingLines.join(", "),
        };
    }

    return {
        streetName: firstLine,
        additionalAddressInfo: lines.slice(1).join(", "),
    };
};

export const mapApplePayAddressToCheckout = (
    address: DeliveryInitialValues,
    countryCode: string,
    addressType: "shipping" | "billing" = "shipping"
): DeliveryInitialValues => {
    const supportsAdditionalAddressInfo =
        addressType === "billing"
            ? formSupportsBillingAdditionalAddressInfo(countryCode)
            : formSupportsShippingAdditionalAddressInfo(countryCode);

    if (supportsAdditionalAddressInfo) {
        return { ...address };
    }

    return {
        ...address,
        streetName: [address.streetName, address.additionalAddressInfo]
            .map((line) => line?.trim())
            .filter(Boolean)
            .join(", "),
        additionalAddressInfo: "",
    };
};
